import React from "react";
import AlertIcon from "@mui/icons-material/WarningAmberOutlined";
import CertIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import PersonIcon from "@mui/icons-material/PersonOutline";
import ClipboardIcon from "@mui/icons-material/AssignmentOutlined";
import { LoadBars, useReady } from "../admin/adminCharts";

const ICONS = { alert: AlertIcon, user: PersonIcon, clip: ClipboardIcon, cert: CertIcon };

/** Thin animated progress bar; `target` draws a marker (0-100). */
export function Bar({ pct, color = "var(--color-ink)", delay = 0, target }) {
  const ready = useReady(300 + delay);
  return (
    <div className="pb"><i style={{ width: ready ? `${Math.max(0, Math.min(100, pct))}%` : 0, background: color }}></i>
      {target != null && <b style={{ position: "absolute", top: 0, bottom: 0, width: 2, left: `${target}%`, background: "var(--color-ink)", opacity: 0.5 }}></b>}</div>
  );
}

/** Icon + title + detail + action rows (the "needs attention" list). */
export function ActionList({ actions }) {
  return (
    <div className="act">{actions.map((a) => {
      const Icon = ICONS[a.icon] || AlertIcon;
      return <div key={a.id} className="ar"><span className={`ic ${a.tone}`}><Icon fontSize="small" /></span><div><p>{a.title}</p><small>{a.detail}</small></div><button type="button" className="go" onClick={a.onClick}>{a.cta}</button></div>;
    })}</div>
  );
}

/** Scheduled hours per instructor against the weekly cap. */
export function LoadList({ rows, emptyText = "No instructors scheduled this week." }) {
  return rows.length ? <LoadBars rows={rows} /> : <p className="wg-empty">{emptyText}</p>;
}

export const Loading = () => <p className="wg-empty">Loading…</p>;
export const LoadFailed = ({ what }) => <p className="wg-empty" role="alert">Could not load {what}.</p>;

export const fmtDate = (value, opts = { month: "short", day: "numeric", year: "numeric" }) => (value ? new Date(value).toLocaleDateString("en-US", opts) : "—");
export const daysUntil = (value, now = new Date()) => Math.round((new Date(new Date(value).toDateString()) - new Date(now.toDateString())) / 86400000);
